export enum DisplayPermission {
  CAN_READ_ORG = "can_read_org",
  CAN_WRITE_ORG = "can_write_org",
  CAN_READ_USER = "can_read_user",
  CAN_WRITE_USER = "can_write_user",
  CAN_READ_FEATURE = "can_read_feature",
  CAN_WRITE_FEATURE = "can_write_feature",
  CAN_READ_DEVICE = "can_read_device",
  CAN_WRITE_DEVICE = "can_write_device",
  CAN_READ_FIRMWARE = "can_read_firmware",
  CAN_WRITE_FIRMWARE = "can_write_firmware",
  CAN_READ_CONFIG = "can_read_config",
  CAN_WRITE_CONFIG = "can_write_config",
  CAN_MANAGE_FIRMWARE_OPERATION = "can_manage_firmware_operation",
  CAN_MANAGE_CONFIGURATION_OPERATION = "can_manage_configuration_operation",
  CAN_MANAGE_CERTIFICATE_OPERATION = "can_manage_certificate_operation",
  CAN_MANAGE_OPTIONS_OPERATION = "can_manage_options_operation",
  CAN_READ_SECTOR = "can_read_sector",
  CAN_WRITE_SECTOR = "can_write_sector",
  CAN_READ_APPLICATION = "can_read_application",
  CAN_WRITE_APPLICATION = "can_write_application",
  CAN_READ_LICENSE = "can_read_license",
  CAN_WRITE_LICENSE = "can_write_license",
  CAN_MANAGE_DEVICE_FLEET_LOG = "can_manage_device_fleet_log",
  CAN_MANAGE_CYBER_LOG = "can_manage_cyber_log",
  CAN_MANAGE_SYSTEM_LOG = "can_manage_system_log",
  CAN_MANAGE_DEVICE_LOG = "can_manage_device_log",
  CAN_READ_FIELD_PERMISSION = "can_read_field_permission",
  CAN_WRITE_FIELD_PERMISSION = "can_write_field_permission",
  CAN_READ_RELATION = "can_read_relation",
  CAN_WRITE_RELATION = "can_write_relation",
  CAN_READ_CERTIFICATE = "can_read_certificate",
  CAN_WRITE_CERTIFICATE = "can_write_certificate",
}
